/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { AdminContractBodyDTO } from '../model/models';
import { ContractCreateBodyDTO } from '../model/models';
import { ContractDTO } from '../model/models';
import { ContractLogPeriodEnumDTO } from '../model/models';
import { ContractStatusChangeDTO } from '../model/models';
import { ContractStatusEnumDTO } from '../model/models';
import { ContractTypeGroupEnumDTO } from '../model/models';
import { ContractsResponseDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CreateContractRequestParams {
    contractCreateBodyDTO: ContractCreateBodyDTO;
}

export class ClsCreateContractRequestParams {
    contractCreateBodyDTO: ContractCreateBodyDTO = undefined;
}

export interface GetContractByCustomerIdentifierRequestParams {
    customerIdentifier: string;
}

export class ClsGetContractByCustomerIdentifierRequestParams {
    customerIdentifier: string = undefined;
}

export interface GetContractByIdRequestParams {
    contractId: string;
}

export class ClsGetContractByIdRequestParams {
    contractId: string = undefined;
}

export interface GetContractsRequestParams {
    contractLogPeriod?: Array<ContractLogPeriodEnumDTO>;
    projectNumber?: string;
    contractTypeGroup?: Array<ContractTypeGroupEnumDTO>;
    filter?: string;
    fccDataCenterEnabled?: boolean;
    fccDataCenterContractTypeGroup?: Array<ContractTypeGroupEnumDTO>;
    search?: string;
    status?: Array<ContractStatusEnumDTO>;
    contractMonth?: string;
    customerName?: string;
    customerIdentifier?: string;
    contractIds?: Array<string>;
    pageSize?: number;
    pageNumber?: number;
    sort?: string;
}

export class ClsGetContractsRequestParams {
    contractLogPeriod?: Array<ContractLogPeriodEnumDTO> = undefined;
    projectNumber?: string = undefined;
    contractTypeGroup?: Array<ContractTypeGroupEnumDTO> = undefined;
    filter?: string = undefined;
    fccDataCenterEnabled?: boolean = undefined;
    fccDataCenterContractTypeGroup?: Array<ContractTypeGroupEnumDTO> = undefined;
    search?: string = undefined;
    status?: Array<ContractStatusEnumDTO> = undefined;
    contractMonth?: string = undefined;
    customerName?: string = undefined;
    customerIdentifier?: string = undefined;
    contractIds?: Array<string> = undefined;
    pageSize?: number = undefined;
    pageNumber?: number = undefined;
    sort?: string = undefined;
}

export interface UpdateContractRequestParams {
    contractId: string;
    ifMatch: string;
    adminContractBodyDTO: AdminContractBodyDTO;
}

export class ClsUpdateContractRequestParams {
    contractId: string = undefined;
    ifMatch: string = undefined;
    adminContractBodyDTO: AdminContractBodyDTO = undefined;
}

export interface UpdateContractStatusRequestParams {
    contractId: string;
    ifMatch: string;
    contractStatusChangeDTO: ContractStatusChangeDTO;
}

export class ClsUpdateContractStatusRequestParams {
    contractId: string = undefined;
    ifMatch: string = undefined;
    contractStatusChangeDTO: ContractStatusChangeDTO = undefined;
}


export interface AdminContractsApiClientInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Create a new contract
     * Create a new contract
* @param requestParameters
     */
    createContract(requestParameters: CreateContractRequestParams, extraHttpRequestParams?: any): Observable<ContractDTO>;

    /**
     * Get a contract detail
     * Get a contract detail for the specified customer identifier.
* @param requestParameters
     */
    getContractByCustomerIdentifier(requestParameters: GetContractByCustomerIdentifierRequestParams, extraHttpRequestParams?: any): Observable<ContractDTO>;

    /**
     * Get a contract detail
     * Get a contract detail for the specified UUID.
* @param requestParameters
     */
    getContractById(requestParameters: GetContractByIdRequestParams, extraHttpRequestParams?: any): Observable<ContractDTO>;

    /**
     * Get all contracts
     * Get all contracts or filter by specified criteria.
* @param requestParameters
     */
    getContracts(requestParameters: GetContractsRequestParams, extraHttpRequestParams?: any): Observable<ContractsResponseDTO>;

    /**
     * Update a contract
     * Update a contract information. It\&#39;s possible to set a date when the change takes effect.
* @param requestParameters
     */
    updateContract(requestParameters: UpdateContractRequestParams, extraHttpRequestParams?: any): Observable<ContractDTO>;

    /**
     * Update a contract status
     * Update the contract status, only DISABLED status can be used here.
* @param requestParameters
     */
    updateContractStatus(requestParameters: UpdateContractStatusRequestParams, extraHttpRequestParams?: any): Observable<ContractDTO>;

}
